import OpusLayerGroup from "lib/classes/opuslayergroup";

interface LayerProps {
	id:string,
	name:string,
	legendOrder:number,
	cartographicOrder:number,
	isHidden:boolean,
	images:string[],
	group:OpusLayerGroup,
	visible?:boolean,
	json?:string
}

/**
	* OpusMaps map layer class
	* 
	* @remarks
	* Used mainly in views/MapLayerTool
	* 
	* @param id				-	ID of the map layer
	* @param name			-	Name of the layer
	* @param isHidden		-	Visibility of map layer
	* @param images			-	Array of urls for the layer image
	* @param group			-	Associated map layer group
	* @param tileLayer		-	Associated OpenLayers tile layer
*/
export default class OpusLayer {
	public id:string;
	public name:string;
	public legendOrder:number;
	public cartographicOrder:number;
	public isHidden:boolean;
	public json:string;
	public images:string[];
	public group:OpusLayerGroup;
	public _visibleInLegendOMV:boolean = false;
	
	private visible:boolean = true;
	private customObj:any;
	
	public get shouldShowOnMap():boolean {
		return this.isHidden !== true && this.group?.shouldShowOnMap !== false;
	}
	public get shouldShowInLegend():boolean {
		return this.customObj?.hiddenInLegend !== true;
	}
	
	constructor({id, name, legendOrder, cartographicOrder, isHidden, images, group, visible, json}:LayerProps) {
		this.id = id;
		this.name = name;
		this.legendOrder = legendOrder;
		this.cartographicOrder = cartographicOrder;
		this.isHidden = isHidden;
		this.images = images;
		this.group = group;
		this.json = json;
		
		try {
			if(typeof this.json === 'string' && this.json)
				this.customObj = JSON.parse(this.json);
		}catch(e:any) { console.error('Error parsing custom layer group json', e); }
		
		// Last step
		this.setVisible(visible, false);
	}
	public setVisible(visible:boolean, callEvent:boolean = true) {
		// Hidden layers in the legend are always visible on the map
		if(!this.shouldShowInLegend) visible = true;
		
		// Hidden layer always invisible
		if(!this.shouldShowOnMap) visible = false;
		
		this.visible = visible;
		this.group.updateAllVisible();
		callEvent && _events.invoke("layer-toggled", this);
	}
	public getVisible():boolean {
		return this.visible;
	}
}